<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="项目详情"
    >
        <div class="container">
            <div class="formCont">
                <el-row style="height:170px;margin-bottom:30px">
                    <el-col :span="6" :push="1" >
                        <div class="charts">
                            <div class="echart-wrap">
                                <v-chart
                                    :auto-resize="true"
                                    :options="barOption"
                                    ref="eleBar"
                                    theme="ovilia-green"
                                />
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="14" :push="3">
                        <div class="charts">
                            <div class="echart-wrap">
                                <v-chart
                                    :auto-resize="true"
                                    :options="pieOption"
                                    ref="elePie"
                                    theme="ovilia-green"
                                />
                            </div>
                        </div>
                        <div class="charts">
                            <!-- <div class="echart-wrap" style="border:1px solid #000;height:150px">
                                
                            </div> -->
                        </div>
                        <div class="charts">
                            <!-- <div class="echart-wrap" style="border:1px solid #000;height:150px">
                                
                            </div> -->
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">项目名称：</div>
                        <div class="content">{{ msg.name }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">项目类型：</div>
                        <div class="content">{{ msg.type_cn }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" v-if="msg.type == 1">
                        <div class="label">计划日期：</div>
                        <div class="content">
                            {{ msg.start_date }} 至 {{ msg.end_date }}
                        </div>
                    </el-col>
                    <el-col :span="12" v-else>
                        <div class="label">开始日期：</div>
                        <div class="content">{{ msg.start_date }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">优先级：</div>
                        <div class="content">
                            <p
                                class="priority"
                                :class="[
                                    msg.priority == 1
                                        ? 'priority1'
                                        : msg.priority == 2
                                        ? 'priority2'
                                        : msg.priority == 3
                                        ? 'priority3'
                                        : msg.priority == 4
                                        ? 'priority4'
                                        : ''
                                ]"
                            >
                                {{ msg.priority }}
                            </p>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">负责人：</div>
                        <div class="content">{{ msg.lead_user_name }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">项目网址：</div>
                        <div class="content">
                            <a :href="msg.website" target="_blank">{{
                                msg.website
                            }}</a>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="label">团队成员：</div>
                        <div class="content">{{ msg.team_cn }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="label">项目描述：</div>
                        <div class="content">
                            <vue-tinymce
                                v-if="detailVisible"
                                v-model="msg.desc"
                                :setting="setting"
                            />
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="detailVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import { mapState } from "vuex";
export default {
    data() {
        return {
            msg: {},
            xAxis: ["未开始", "进行中", "已完成", "已结束"],
            yAxis: []
        };
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object
    },
    watch: {
        detailVisible: {
            handler(newValue) {
                if (newValue) {
                    this.project();
                    this.projectReport();
                }
            }
        }
    },
    created() {},
    methods: {
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:detailVisible", false);
        },
        project() {
            oaApi.project({}, "get", this.tableItem.id).then(res => {
                //console.log(res);
                if (res.code == 200) {
                    this.msg = res.data;
                    //console.log(this.msg);
                }
            });
        },
        projectReport() {
            oaApi
                .projectReport({ project_id: this.tableItem.id }, "get")
                .then(res => {
                    let {
                        not_start,
                        in_progress,
                        finish_num,
                        close_num
                    } = res.data;
                    this.yAxis = [
                        not_start,
                        in_progress,
                        finish_num,
                        close_num
                    ];
                });
        }
    },
    components: {},
    computed: {
        ...mapState({
            setting: state =>
                Object.assign(JSON.parse(JSON.stringify(state.index.setting)), {
                    readonly: true
                })
        }),
        barOption() {
            const options = {
                grid: {
                    left: "-1%",
                    right: "2%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                color: ["#eb5202"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "公司",
                        data: this.xAxis,
                        axisTick: false,
                        axisLine: {
                            lineStyle: {
                                color: "#f4f4f4"
                            }
                        },
                        axisLabel: {
                            color: "#bcbccf"
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        // name: "（个）",
                        axisLine: false,
                        splitLine: false
                    }
                ],
                series: [
                    {
                        name: "项目状态",
                        type: "bar",
                        barWidth: "10",
                        data: this.yAxis,
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true, //开启显示
                                    position: "top", //在上方显示
                                    textStyle: {
                                        //数值样式
                                        color: "black",
                                        fontSize: 15,
                                        fontWeight: 600
                                    }
                                },
                                barBorderRadius: [5, 5, 0, 0]
                            }
                        }
                    }
                ]
            };
            return options;
        },
        pieOption() {
            const handred = 100;
            // let point = 66;
            const options = {
                title: {
                    x: "center",
                    y: "32%",
                    subtext: this.msg.progress + "%",
                    itemGap: 15,
                    subtextStyle: {
                        fontWeight: "bold",
                        color: "#000000",
                        fontSize: "23"
                    },
                    text: "总进度",
                    textStyle: {
                        color: "#bcbccf",
                        fontSize: "12"
                    }
                },
                series: [
                    {
                        name: "circle",
                        type: "pie",
                        clockWise: true,
                        radius: ["65%", "80%"],
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            }
                        },
                        hoverAnimation: false,
                        data: [
                            {
                                value: this.msg.progress || 0,
                                name: "已完成",
                                itemStyle: {
                                    normal: {
                                        color: "#ff5a02",
                                        label: {
                                            show: false
                                        },
                                        labelLine: {
                                            show: false
                                        }
                                    }
                                }
                            },
                            {
                                name: "总进度",
                                value: handred - this.msg.progress || 0,
                                itemStyle: {
                                    normal: {
                                        color: "#E1E8EE"
                                    }
                                }
                            }
                        ]
                    }
                ]
            };
            return options;
        }
    }
};
</script>

<style lang="scss" scoped>

</style>
